var exports = {
  "i": "xaee3c4fa--d64b52--wrapper",
};

module.exports = exports;
